import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import classnames from 'classnames';
import ModalContent from './Content.js';
import ModalCard from './Card.js';
import styles from './Modal.scss';

export default class Modal extends PureComponent {
  static Content = ModalContent;
  static Card = ModalCard;

  static defaultProps = {
    show: true,
    fullscreen: false,
    className: '',
    // Expose mount point for testing
    document: null,
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  componentDidMount() {
    const d = this.getDocument();
    this.portalElement = d.createElement('div');
    this.portalElement.setAttribute('class', 'modal-container');
    this.getModalContainer().appendChild(this.portalElement);
    this.setState({ d });
  }

  componentWillUnmount() {
    this.portalElement.remove();
  }

  getModalContainer = () => {
    const d = this.getDocument();
    switch (process.platform) {
      case 'darwin':
        return d.getElementById('drag-region') || d.body;
      default:
        return d.body;
    }
  };

  getDocument = () => {
    const { document: propDocument } = this.props;
    if (propDocument) {
      return propDocument;
    }

    if (typeof document !== 'undefined') {
      return document;
    }

    return null;
  };

  portalElement = null;

  render() {
    const { show, className, fullscreen, allowBackgroundInteraction } =
      this.props;

    if (!this.getDocument() || !this.portalElement || !show) {
      return null;
    }

    let { children } = this.props;

    return ReactDOM.createPortal(
      <div
        // Portal events bubble through the React tree, not the DOM tree, so
        // without this a click inside the modal would also fire handlers on
        // whatever component the modal was triggered from (e.g. a clickable row)
        onClick={(event) => event.stopPropagation()}
        className={classnames(
          'modal',
          styles.modal,
          allowBackgroundInteraction && styles.allowBackgroundInteraction,
          className,
          {
            'is-active': show,
          },
        )}
      >
        {!fullscreen && !allowBackgroundInteraction && (
          <div role="presentation" className="modal-background" />
        )}
        {children}
      </div>,
      this.portalElement,
    );
  }
}
